import MODULE_NAME from "./constants";

export const SETONLYSTREAMING = `${MODULE_NAME}/SETONLYSTREAMING`;

export const setOnlyStreaming = ({
  isOnlyStreaming,
  onlyStreamingCenterCostId,
}) => ({
  type: SETONLYSTREAMING,
  payload: { isOnlyStreaming, onlyStreamingCenterCostId },
});
